import { Content, Main } from "../../../components/Layout";
import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import useWrapper from "../../../hooks/useWrapper";
import { traineeFinancial } from "../../../hooks/api/listFinancial";
import { toast } from "react-toastify";
import { Row, Col } from "react-bootstrap";
import TraineeSubMenu from "../../../components/Submenu/TraineeSubMenu";
import Loading from "../../../components/Loading";
import SlipsTable from "../../../components/SlipsTable";
import useFormat from "../../../hooks/utils/useFormat";

export default function TraineesCharges() {
  const { me, config } = useWrapper();
  const { trainee, setisWaitingResponse } = useOutletContext() || {};

  const [reloadFinancial, setreloadFinancial] = useState();
  const reloadFinancialData = () => {
    setreloadFinancial(JSON.stringify(new Date()));
  };

  const [financial, setfinancial] = useState();
  useEffect(() => {
    (async () => {
      try {
        setisLoadingSlips(true);
        const _financial = await traineeFinancial({
          config,
          me,
          trainee_id: trainee?.id,
          commercial_id: trainee?.commercial_id,
        });
        setfinancial(_financial);
      } catch (__error) {
        console.log("__error", __error);
        toast.error("Problema ao carregar os pagamentos");
      } finally {
        setisLoadingSlips(false);
      }
    })();
  }, [reloadFinancial]);

  const [isLoadingSlips, setisLoadingSlips] = useState();
  useEffect(() => {
    setisWaitingResponse(isLoadingSlips);
  }, [isLoadingSlips]);

  const updateSlip = props => {
    const { slip_id, update } = props;
    setfinancial({
      ...financial,
      payment_slips: {
        ...financial?.payment_slips,
        charges: financial?.payment_slips?.charges?.map(__slip => {
          return __slip.id === slip_id
            ? {
                ...__slip,
                ...update,
              }
            : __slip;
        }),
      },
    });
  };

  return (
    <Row>
      <Col sm={9}>
        <Main>
          {!isLoadingSlips ? (
            <>
              <Content>
                <Row>
                  <Col>
                    <h2 className="mini-title">
                      Pagamentos Ativos: <span className="small-label">(Cobranças Extras)</span>
                    </h2>
                    <p className="small-label mb-2">
                      Boletos com vencimento em finais de semana e feriados poderão ser pagos no próximo dia útil sem
                      multas e taxas.
                    </p>
                  </Col>
                </Row>
                <SlipsTable
                  slips={financial?.payment_slips?.charges
                    ?.filter(__payment => __payment.status !== "Cancelado")
                    ?.filter(__payment => __payment.status !== "Pago")}
                  updateSlip={__update => {
                    updateSlip({
                      slip_id: __update.slip_id,
                      update: __update.update,
                    });
                  }}
                  show_total={true}
                  reload={reloadFinancialData}
                />
                <Row className="mt-4">
                  <Col>
                    <h2 className="mini-title">Pagamentos Efetuados:</h2>
                    <p className="small-label mb-2">
                      Histórico dos pagamentos realizados. Revise as transações para confirmar os valores quitados.
                    </p>
                  </Col>
                </Row>
                <SlipsTable
                  slips={financial?.payment_slips?.charges?.filter(__payment => __payment.status === "Pago")}
                  paid_values={true}
                  show_total={true}
                />
              </Content>
            </>
          ) : (
            <Content>
              <Loading />
            </Content>
          )}
        </Main>
      </Col>
      <Col sm={3}>
        <TraineeSubMenu trainee={trainee} />
      </Col>
    </Row>
  );
}
